module.exports = __webpack_public_path__ + "static/feature-1-5f12c9a0fbb3fae9501d902b343d044f.svg";